export const getFormattedCompanyRegNumber = (value: string): string => {
  // Remove everything except digits
  const digits = value.replace(/\D/g, "").slice(0, 10);

  if (digits.length <= 6) {
    return digits;
  }

  return `${digits.slice(0, 6)}-${digits.slice(6)}`;
};
